var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.type],style:({ color: _vm.color })},[(_vm.hasAmount)?_c('span',{staticClass:"symbol",style:({ fontSize: _vm.symbolSize })},[_vm._v(_vm._s(_vm.symbolByLocale))]):_vm._e(),_c('span',{staticClass:"amount",style:({ fontSize: _vm.amountSize })},[_vm._v(_vm._s(_vm.formattedAmount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }